<template>
  <!-- 大会概况 -->
  <div class="surveyWrap contentBox">
    <!-- 内容 -->
    <div class="surveyBox">
      <router-link class="index-title" :to="{ path: '/survey', query:{ name: name } }" target="_blank">{{ name }}</router-link>
      <!-- 越极限 -->
      <div class="survey_sloganBox">
        <img src="../assets/image/GuidePage_txt.png" class="textImg1" />
      </div>
      <p class="survey_title" v-if="ispc">——城市复杂环境下隧道工程的挑战与创新</p>
      <div class="survey_cont" v-html="content"></div>
      <!-- 会议简介 -->
      <ul class="survey_intr">
        <li v-for="(item,index) in intr" :key="index">
          <router-link :to="{ path: '/newsDetails', query:{ name: '新闻中心', subName: '动态追踪', newsId: 67,topicId: 11 } }">
            <div class="intr_title"><img :src="item.iconPath" /></div>
            <p v-text="item.content"></p>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default{
    name: 'IndexSurvey',
    props:{
      name: {
        type: String,
        default: '大会概况'
      },
      content: {
        type: String,
        default: ''
      },
      ispc: {
        type: Boolean,
        default: true
      }
    },
    data() {
        return {
            intr: [
                {iconPath: 'static/img/highlights_title_1.png', content: '国际隧协特邀指导，国内高水平学会联合主办，国内外顶尖的技术大咖与企业代表参与。'},
                {iconPath: 'static/img/highlights_title_2.png', content: '聚焦城市复杂环境下地下工程建设，国内外不同技术交流碰撞，全球视野更新颖。'},
                {iconPath: 'static/img/highlights_title_3.png', content: '涵盖地下工程领域建设、设计、施工、科研院所、高校及相关供应商，是行业最为专业的会议。'},
                {iconPath: 'static/img/highlights_title_4.png', content: '超大直径盾构隧道、轨道交通与地下空间开发、智能化精细化、创新地下工程装备等内容精彩不断，不同层面全面分析。'},
                {iconPath: 'static/img/highlights_title_5.png', content: '本次会议将建立专门直播间，邀请重量级嘉宾进行为期2天的专业 “云分享”，让你足不出户也能够获取最具前沿的行业动态，并拥有和各位大咖展开思想碰撞的机会，以“云”的形式洞见行业未来发展趋势！'}
            ]
        }
    }
  }
</script>

<style scoped>
  @media screen and (min-width: 1029px) {
    .surveyBox {
      margin-top: 130px;
    }

    .survey_sloganBox {
      width: 460px;
      margin: 0 auto;
    }

    .survey_sloganBox img {
      width: 100%;
    }

    .survey_title {
      font-size: 28px;
      line-height: 32px;
      color: #ffffff;
      text-align: center;
    }

    .survey_cont {
      font-size: 16px;
      line-height: 32px;
      color: #ffffff;
      text-align: justify;
    }

    /* 简介 */
    .survey_intr{
      display: flex;
      justify-content: space-between;
      margin: 30px 0 95px;
    }

    .survey_intr li{
      width: 220px;
      height: 308px;
      padding: 20px 15px;
      background-color: rgba(0, 0, 0, .3);
    }

    .survey_intr li a{
      display: block;
      color: #FFFFFF;
    }

    .survey_intr .intr_title{
      text-align: center;
      margin-bottom: 14px;
    }

    .survey_intr li p{
      font-size: 16px;
      line-height: 24px;
      text-indent: 32px;
    }
  }
  @media screen and (min-width: 320px) and (max-width: 1024px) {
    .surveyBox {
      margin-top: 1rem;
    }

    .survey_cont {
      width: 85%;
      font-size: .28rem;
      line-height: .48rem;
      color: #ffffff;
      margin: .54rem auto 0;
      text-align: justify;
    }

    .survey_sloganBox {
      width: 75%;
      margin: 0 auto;
    }

    .survey_cont p {
      margin-bottom: .1rem;
    }

    .survey_sloganBox img {
      width: 100%;
    }

    /* 简介 */
    .survey_intr{
      width: 85%;
      margin: .4rem auto 1.3rem;
    }

    .survey_intr li{
      padding: .1rem .2rem;
      background-color: rgba(0, 0, 0, .3);
      margin-bottom: .2rem;
    }

    .survey_intr li a{
      display: flex;
      align-items: center;
      color: #FFFFFF;
    }

    .survey_intr .intr_title img{
      width: 1.48rem;
      height: .4rem;
    }
    .survey_intr li p{
      font-size: .28rem;
      line-height: .48rem;
      margin-left: .2rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/IndexSurvey.vue